import { Injectable, inject } from '@angular/core';
import { UserRoleEnum } from '@shared/helpers/enums/user-role';
import { QueryOptions } from 'odata-query';
import { map, Observable, shareReplay } from 'rxjs';
import { GstarClient } from '../../../web-api-client';
import { mapUserRoleFromResponse } from '../mappers';
import { Collection, UserRole } from '../models';

@Injectable({
  providedIn: 'root',
})
export class UserRoleService {
  private readonly gstarClient = inject(GstarClient);

  private cache$!: Observable<Collection<UserRole>> | null;

  /**
   * External user role is not available for Internal Users
   */
  private readonly getInternalUserFilter = `name ne '${UserRoleEnum.ExternalUser}'`;

  getInternalUserRoles(
    query?: Partial<QueryOptions<UserRole>>
  ): Observable<Collection<UserRole>> {
    if (!this.cache$) {
      this.cache$ = this.gstarClient
        .userrolesGET2(
          undefined,
          this.getInternalUserFilter,
          query?.top?.toString(),
          query?.skip?.toString(),
          query?.orderBy?.toString(),
          query?.count?.toString(),
          undefined
        )
        .pipe(
          map(response => ({
            total: response.odataCount ?? 0,
            items:
              response.value?.map(response =>
                mapUserRoleFromResponse(response)
              ) ?? [],
          })),
          shareReplay(1)
        );
    }

    return this.cache$;
  }
}
